import { AiSaasOutputProvider, useAiSaasOutputContainer } from "..";
import css from "./index.module.scss";
import classNames from "classnames";
import AISaasItemContent from "../ItemContent";
import SortableList from "@uiview/views/AISaas/SortableList/container/List";
import { useAISaasContainer } from "@uiview/views/AISaas/container";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { getIt } from "@uikit/getIt";
import { useStore } from "imagica-uikit/dist/hooks/useStore";
import { PublishSubscriptionStore } from "imagica-corekit/dist/cases/store/PublishSubscriptionStore";

function AiSaasOutputListInner() {
  const { dndThoughts, className, onChange } = useAiSaasOutputContainer();
  const { outputListRef } = useAISaasContainer();
  const {
    saasAndThinkState: { saasUIData },
  } = useHomeUsePluginContainer();
  const store = getIt(PublishSubscriptionStore);
  const state = useStore(store).value;

  /**
   * 默认loading为ture，即默认情况先隐藏output
   * loading结束才获取到完整数据，再进行以下判断
   * static下付费APP且没有付费才隐藏
   */
  const hideOutputNode = () => {
    if (saasUIData?.staticMode) {
      if (state.loading) {
        return true;
      } else {
        return state.isPaidApp && !state.isPay;
      }
    }
    return false;
  };

  return (
    <div className={css["moddle-box"]}>
      <div className={css["max-width-box"]}>
        <div className={css["output-list"]} ref={outputListRef}>
          <div className={classNames(css["AiSaasOutputList"], className, "globalAiSaasOutputList")}>
            <SortableList<AISaasOutput.DndThoughtWithGroupType>
              disabled
              isShare
              listType="output"
              onChange={onChange}
              options={dndThoughts}
              renderItemChildren={item => (
                <div className={css["groupThought"]}>
                  {!hideOutputNode() &&
                    item.value.data.groupDnd.map((thought, index) => (
                      <AISaasItemContent key={thought.id} thought={thought} index={index} />
                    ))}
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AiSaasOutputList(props: AISaasOutput.AiSaasOutputListProps) {
  return (
    <AiSaasOutputProvider initialState={props}>
      <AiSaasOutputListInner />
    </AiSaasOutputProvider>
  );
}
